export  const MyValidateMessages = {
  required: '${label} 是必填选项',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} 不是一个合规的数字',
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "小于 ${min}",
    max: "不大于${max}",
    range: "'${label}' 必须在 ${min} 到 ${max}",
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "上限${max}字",
    range: "'${name}' must be between ${min} and ${max} characters",
  },
};